import { createMachine } from "xstate"
import {
    SendUserEvent,
    UserEventsContext,
    UserEventsStateMachine,
    UserEventsTypes,
    WindowLocation,
} from "./user-events-machine"

export const userEventsMachineV4 = (
    context: UserEventsContext,
    sendUserEvent: SendUserEvent,
    windowLocation: WindowLocation = defaultWindowLocation,
): UserEventsStateMachine => {
    type Context = UserEventsTypes["Context"]
    type Events = UserEventsTypes["Events"]
    type TypeState = UserEventsTypes["TypeState"]

    // TODO - unbundling: re-implement user events machine when new backend is ready
    return createMachine<Context, Events, TypeState>(
        {
            id: "userEvents",
            initial: "disabled",
            predictableActionArguments: true,
            context,
            states: {
                restoring: {},
                disabled: {},
                enabled: {},
            },
        },
        {
            guards: {},
            actions: {},
        },
    )
}

export const defaultSendUserEventV4 =
    (dotComApiBaseUrl: string): SendUserEvent =>
    async (event) => {
        await fetch(new URL("userEvents", dotComApiBaseUrl), {
            method: "POST",
            body: JSON.stringify(event),
            credentials: "include",
        })
    }

const defaultWindowLocation: WindowLocation = () => new URL(window.location.href)
